import React, { useState, useEffect, useRef } from 'react';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../shared/ShowError';
import Laoding from '../shared/Laoding';
import { InputTextarea } from 'primereact/inputtextarea';

var timer = null;
export default function Chat(props) {
    const navigate = useNavigate();
    const [text, setText] = useState("");
    const [loadingChat, setLoadingChat] = useState(true);
    const [saving, setSaving] = useState(false);
    const [chats, setChats] = useState([]);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const targetRef1 = useRef(null);

    useEffect(() => {
        setLoadingChat(true);
        var params = {
            login:util.getLoginDto(), 
        };
        var url = config.Server+`/chat/list`;
        console.log("url in select ipg is>", url)
        console.log("params in select ipg is>", params)
        axios
        .post(url, params )
        .then(response => {
            console.log("main response is>", response)
            var response = response.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("resopnse is> ", response); 
                var user = util.getCurrentUser();
                for(var i=0;i<response.length;i++){
                    response[i]["isForMe"] = false;
                    if(response[i].user.id == user.id){
                        response[i]["isForMe"] = true;
                    }
                }
                setChats(response);
                setLoadingChat(false);
                startTimout(3000);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                console.log("error is>", response.message);
                startTimout(3000);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            startTimout(3000);
        });
    }, []);
    const startTimout = function(time){
        timer = setTimeout(() => {
                
                var lastDate = 0;
                var lastTime = 0;
                if(chats.length>0){
                    lastDate = chats[chats.length-1].issueDate;
                    lastTime = chats[chats.length-1].issueTime;
                }
                var params = {
                    login:util.getLoginDto(), 
                    lastDate:lastDate,
                    lastTime:lastTime
                };
                var url = config.Server+`/chat/recent/list`;
                axios
                .post(url, params )
                .then(response => {
                    var response = response.data;
                    if(response.state === "ok"){
                        response = response.data;
                        var user = util.getCurrentUser();
                        var ncs = [...chats];
                        console.log("ncs 111 is>", chats);
                        for(var i=0;i<response.length;i++){
                            response[i]["isForMe"] = false;
                            if(response[i].user.id == user.id){
                                response[i]["isForMe"] = true;
                            }
                            var ind = ncs.findIndex(x=>x.id == response[i].id);
                            if(ind == -1){
                                ncs.push({...response[i]});
                            }
                        }
                        console.log("ncs is>", ncs);
                        setChats(ncs);
                        startTimout(3000);
                    }
                    else{
                        console.log("error is>", response.message);
                        startTimout(3000);
                    }
                })
                .catch(error => {
                    console.log("error is>", error);
                    startTimout(3000);
                });
        
        
        
            }, time);
        console.log("timer is>", timer);
        
    }
    const onInputChange = function(e,){
        var val = '';
        val = (e.target && e.target.value) || '';
        setText(val);
    }
    const onInputTextKeyDown = function(e,){
        if(e.ctrlKey || e.altKey || e.shiftKey) return;
        if(e.code == "Enter"){
            sendText();
        }
    }
    const sendText = function(){
        if(text.trim() == ""){
            setText("");
            return;
        }
        clearTimeout(timer);
        var url = config.Server + `/chat/insert`;
        var params = {
            login:util.getLoginDto(), 
            text:text,
        };
        setSaving(true);
        console.log("user is>", params);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var ncs = [...chats];
                response["isForMe"] = true;
                ncs.push(response);                
                setChats(ncs);
                setSaving(false);
                setText("");
                util.scrollToElement(targetRef1, "end");
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
                setText(text.trim());
            }
            startTimout();
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
            setText(text.trim());
            startTimout();
        });

    }
    const deleteChat = function(c, cInd){
        clearTimeout(timer);
        var url = config.Server + `/chat/delete`;
        var params = {
            login:util.getLoginDto(), 
            id:c.id,
        };
        setSaving(true);
        console.log("user is>", params);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var ncs = [...chats];
                ncs.splice(cInd, 1);
                setChats(ncs);
                setSaving(false);
                startTimout();
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
                startTimout();
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
            startTimout();
        });

    }
    return(
        (loadingChat)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت پیام ها..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            <div style={{padding:"0px", margin:"0px 0px 20px 0px", position:"relative", height:"calc(100vh - 200px)", overflowY:"scroll"}} ref={targetRef1}>
                {
                    chats.map((c, cInd)=>{
                        return(
                            <div style={{width:"calc(100% - 15px)", border:"1px solid #999", padding:"0px", margin:(c.isForMe?"10px 0px 0px 15px":"10px 15px 0px 0px"), backgroundColor:(c.isForMe?"#ebfaeb":"#fff"), position:"relative"}}>
                                <div style={{width:"100%", fontSize:"8pt", borderBottom:"1px dashed #999", padding:"0px 5px"}}>
                                    {c.user.firstname + " " + c.user.lastname}, {util.toPersianDigits(util.SeperateDate(c.issueDate))}-{util.toPersianDigits(util.SeperateTime(c.issueTime))}
                                </div>
                                <div style={{width:"100%", fontSize:"11pt", padding:"5px"}}>
                                    <pre>{c.text}</pre>
                                </div>
                                {
                                    c.isForMe?
                                    <i onClick={()=>{deleteChat(c, cInd)}} class="pi pi-trash" style={{position:"absolute", left:"10px", bottom:"10px", zIndex:"100", color:"#9b3434", fontSize:"16pt", cursor:"pointer"}} title="حذف"></i>
                                    :<></>
                                }
                                    
                                
                            </div>
                        )
                    })
                }
                
            </div>
            <div style={{position:"fixed", width:"calc(100% - 32px)", left:"15px", bottom:"5px", border:"1px solid #9cccf8ff", height:"100px", padding:"0px", borderRadius:"5px"}}>
                <InputTextarea onKeyDown={(e)=>{onInputTextKeyDown(e)}} value={text} onChange={(e)=>{onInputChange(e)}} keyfilter="" maxLength={2000} className="p-inputtext-lg" style={{width:"100%", height:"100%", textAlign:"right", direction:"rtl",margin:"0px", padding:"5px"}} />
                <Button label="" icon="pi pi-send" onClick={()=>sendText()} severity="secondary" loading={saving} iconPos="right" style={{borderRadius:"5px", position:"absolute", left:"10px", bottom:"10px", transform:"rotate(-90deg)"}} />
                {/* <Button label="" icon="pi pi-refresh" onClick={()=>startTimout(10)} severity="secondary" loading={saving} iconPos="right" style={{borderRadius:"5px", position:"absolute", left:"60px", bottom:"10px", transform:"rotate(-90deg)"}} /> */}
            </div>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}